import { render, staticRenderFns } from "./HeaderMenuItem.vue?vue&type=template&id=a0b0c624"
import script from "./HeaderMenuItem.vue?vue&type=script&lang=ts"
export * from "./HeaderMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports